module.exports = __webpack_public_path__ + "static/media/Montserrat-Bold.9791dd18.ttf";